/* Article body images.

   The store has no article metafields, so a recipe's steps are the numbered
   list the author writes in the body. Any image inside that body arrives as
   a bare <img> from the rich-text editor: no dimensions, no srcset, eager.
   That is exactly what shifts a method as the reader scrolls it.

   This upgrades each one in place — a held box from the image's own aspect
   ratio once known, a srcset from Shopify's CDN widths, lazy loading and
   async decoding. Nothing is moved or restyled; only the loading behaviour
   changes.

   Structured step data would be better and needs article metafields.
*/

(function () {
  'use strict';

  const WIDTHS = [400, 600, 800, 1200];

  function cdnSrcset(src) {
    // Shopify CDN URLs accept a width query parameter.
    if (!/cdn\.shopify\.com|\/cdn\/shop\//.test(src)) return null;
    const base = src.split('?')[0];
    return WIDTHS.map(function (w) { return base + '?width=' + w + ' ' + w + 'w'; }).join(', ');
  }

  function upgrade(img) {
    if (img.dataset.dopaUpgraded) return;
    img.dataset.dopaUpgraded = '1';

    if (!img.getAttribute('loading')) img.loading = 'lazy';
    if (!img.getAttribute('decoding')) img.decoding = 'async';

    const set = cdnSrcset(img.currentSrc || img.src || '');
    if (set && !img.getAttribute('srcset')) {
      img.setAttribute('srcset', set);
      if (!img.getAttribute('sizes')) img.setAttribute('sizes', '(min-width: 1025px) 640px, 100vw');
    }

    function hold() {
      // Hold the box so a late-arriving step photograph shifts nothing.
      if (img.naturalWidth && img.naturalHeight) {
        if (!img.getAttribute('width')) img.setAttribute('width', img.naturalWidth);
        if (!img.getAttribute('height')) img.setAttribute('height', img.naturalHeight);
        img.style.aspectRatio = img.naturalWidth + ' / ' + img.naturalHeight;
      }
    }

    if (img.complete) hold();
    else img.addEventListener('load', hold, { once: true });
  }

  /* SERVES − 4 +. Every quantity the section could read as a number carries
     data-qty (and data-unit); the stepper scales them from the recipe's own
     serving count. The pack offered in a chip does not change. */
  function formatQty(n) {
    if (n >= 10) return String(Math.round(n));
    const r = Math.round(n * 10) / 10;
    return String(r);
  }
  function bindServes() {
    document.querySelectorAll('[data-dopa-serves]').forEach(function (box) {
      if (box.dataset.servesBound) return;
      box.dataset.servesBound = '1';
      const base = parseFloat(box.dataset.base);
      const out = box.querySelector('[data-serves-value]');
      if (!base || !out) return;
      const section = box.closest('section') || document;
      const qtys = section.querySelectorAll('[data-qty]');
      let serves = base;
      box.querySelectorAll('[data-step]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          serves = Math.max(1, Math.min(40, serves + parseInt(btn.dataset.step, 10)));
          out.textContent = serves;
          qtys.forEach(function (q) {
            const v = parseFloat(q.dataset.qty);
            if (isNaN(v)) return;
            const unit = q.dataset.unit ? ' ' + q.dataset.unit : '';
            q.textContent = formatQty(v * serves / base) + unit;
          });
        });
      });
    });
  }

  function boot() {
    bindPrint();
    bindServes();
    const body = document.querySelector('[data-dopa-article-body]');
    if (!body) return;
    body.querySelectorAll('img').forEach(upgrade);
    body.querySelectorAll('iframe, video').forEach(function (el) {
      if (!el.getAttribute('loading')) el.setAttribute('loading', 'lazy');
    });
  }

  /* Print is the browser's; the button only asks for it. A recipe is cooked
     from, and a kitchen printout is the one place this page is read away from
     a screen. Bound in boot() so the theme editor's section reload rebinds it,
     and guarded so a rebind does not stack a second listener. */
  function bindPrint() {
    document.querySelectorAll('[data-dopa-print]').forEach(function (el) {
      if (el.dataset.printBound) return;
      el.dataset.printBound = '1';
      el.addEventListener('click', function () { window.print(); });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
